<a *ngIf="look=='fa'" class="btn btn-outline-danger btn-sm" title="Delete" (click)="deleteItem()">
  <i class="fas fa-trash"></i>
</a>

<a *ngIf="look=='bx'" href="javascript: void(0);" (click)="deleteItem()">
  <i title="Delete" class="bx bx-trash text-danger"></i>
</a>
